import React from 'react';
import useAuth from '../../../Hooks/useAuth';
import {
  GreetContainer, GreetInfo, GreetWrapper, NameGreet, GreetInfo2, GreeterBg, GreetTextWrapper,
} from './greetElements';

const index = () => {
  const { auth } = useAuth();
  return (
    <GreetContainer>
      <GreeterBg>
        <GreetTextWrapper>
          <NameGreet>
            Welcome
            {' '}
            {auth.name}
            ,
          </NameGreet>
          <GreetInfo>
            to our registry of tropical forests that are
            threatened by poverty-driven deforestation.
          </GreetInfo>
        </GreetTextWrapper>
      </GreeterBg>
      <GreetWrapper>
        <GreetInfo2>
          We empower impact sponsors to pay-to-preserve old growth tropical forests
          while also funding community regeneration. We use your impact sponsorship
          to fund sustainable and profitable local companies that reduce poverty-driven
          deforestation. Your intervention is a major weapon in the fight against global
          warming. In return for your sponsorship, we give you a NFT impact certificate.
          Each of our impact certificates reports the estimated carbon removal rate of
          one dedicated hectare of one of our old growth tropical forests. Impact sponsors,
          like you, can use their carbon removal rights to compensate for any of their
          carbon emissions that they cannot eliminate.
        </GreetInfo2>
      </GreetWrapper>
    </GreetContainer>
  );
};

export default index;
